module.exports = __webpack_public_path__ + "img/sec3_lang_center_m.7aa377f8.png";